import React, { Component } from 'react'
import {
  FirstName,
  LastName,
  Email,
  Username,
  Sfid,
  SaveButton,
  ErrorMessage,
  PasswordReset,
  ResendInvite,
  Name,
  State,
  Period, } from './ActionBlockComponents'
  import {  Row, Col } from 'reactstrap'

import { BeatLoader } from 'react-spinners'
import validateFields from '../../../../../helpers/users/manageUsers/validateFields';
import saveChanges from '../../../../../helpers/users/manageUsers/saveChanges';
import { endianness } from 'os';

class ActionBlock extends Component {

  state = {
    firstName: this.props.record.firstName ? this.props.record.firstName + '' : '',
    lastName: this.props.record.lastName ? this.props.record.lastName + '' : '',
    username: this.props.record.username ? this.props.record.username + '' : '',
    email: this.props.record.email ? this.props.record.email + '' : '',
    sfid: this.props.record.sfid ? this.props.record.sfid + '' : '',
    changed: false,
    saving: false,
    error: '',
    saved: false,
    validation: {},
    name: this.props.record.name ? this.props.record.name + '' : '',
    state: this.props.record.state ? this.props.record.state + '' : '',
    period: this.props.record.period ? this.props.record.period + '' : '',
  }

  oChg = ({target}) => {
    let validation = {...this.state.validation}
    if (this.state.validation[target.name]) {
      validation = {}
    }
    this.setState({[target.name]: target.value, changed: true, saved: false, validation})
  }

  oSave = () => {
    const { record } = this.props
    const { firstName, lastName, username, email, sfid, name, state, period } = this.state
    this.setState({saving: true, error: ''})
    const validationErr = validateFields(this.props.record, this.state,)
    if (validationErr) {
      this.setState({validation: validationErr, saving: false})
    } else {
      const data = {firstName, lastName, username, email, sfid, name, state, period}
      saveChanges(record, data)
        .then(() => this.setState({saved: true, changed: false, saving: false, error: '', validation: {}}))
        .catch((err) => {
          const errorMessage = err === 'Email or username already in use.' || err === 'No changes to save.' ? err : 'Error saving changes.'
          this.setState({saving: false, error: errorMessage})
        })
    }
  }

  render() {
    const { record, user, recordType } = this.props
    const { role } = record
    const {
      firstName,
      lastName,
      username,
      email,
      sfid,
      saving,
      changed,
      saved,
      validation,
      error,
      name,
      state,
      period 
    } = this.state
    const is_super_admin = user && user.role === 'Super Administrator'
    const display_username = role === 'Student' || role === 'Teacher'
    return (
      <Col className='action-block' xs='12' sm='11'>
      <Row>
        <Col md='12' sm='12' lg='4'>
        {role
          ? <div>
              <FirstName oChg={this.oChg} val={firstName} err={validation} />
              <LastName oChg={this.oChg} val={lastName} err={validation} />
              {display_username && <Username oChg={this.oChg} val={username} err={validation}/>}
            </div>
          : null
        }

        {!role
          ? <div>
              <Name oChg={this.oChg} val={name} err={validation} />
              {recordType === 'district' &&
                <State oChg={this.oChg} val={state} err={validation}  />
              }
              {recordType === 'class' &&
                <Period oChg={this.oChg} val={period} err={validation} />
              }
            </div>
          : null
        }
        </Col>
        
        {role
          ?
          <Col md='12' sm='12' lg='6' style={{margin: '0 0 auto 0'}}> 
          <div>
              <Email oChg={this.oChg} val={email} err={validation} />
          </div>

            {role && record.validated
          ? <PasswordReset record={record}/>
          : null
        }
        {role && !record.validated
          ? <ResendInvite record={record}/>
          : null
          } 
            </Col>
          : null
        }
        
        {is_super_admin &&
          <Sfid oChg={this.oChg} val={sfid} />
        }
        {Object.keys(validation).length > 0
          ? <ErrorMessage>{validation[Object.keys(validation)[0]]}</ErrorMessage>
          : null
        }
        {error
          ? <ErrorMessage>{error}</ErrorMessage>
          : null
        }
        </Row>
        <Row className="text-center">
        <Col style={{textAlign: '', margin: '0 0 0 auto'}}>
        <SaveButton changed={changed} oSave={this.oSave}>
          {saving
            ? <BeatLoader loading={saving} />
            : (saved ? 'Saved' : 'Save')
          }
        </SaveButton>
        </Col>
        </Row>
      </Col>
    )
  }
}

export default ActionBlock


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlock.js